export default __webpack_public_path__ + "img/MYMY-logo-black.a6a86fe3c5e2c23ac6e5451a8e49ce05.svg";